import React from 'react';
import ReportUpload from './ReportUpload';

const EmailTemplates = () => {
  return <ReportUpload mode="templates" />;
};

export default EmailTemplates;
